// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonButton, IonSpinner } from "@ionic/react"
import { useRef, useState } from "react"


interface LoadingIonButtonProps  extends React.ComponentProps<typeof IonButton> {
  children?: React.ReactNode | string
  disabled?: boolean
  loading?: boolean
  onError?: (result: any) => void | Promise<void>
  onSubmit(): void | Promise<void>
}


const LoadingIonButton: React.FC<LoadingIonButtonProps> = ({
  children,
  disabled,
  ...props
}) => {
  const [loading, setLoading] = useState<boolean>((props.loading !== undefined) ? props.loading : false)
  const element = children
  const onError = props.onError || (() => {})
  const onSubmit = props.onSubmit || (() => {})
  const ref = useRef<HTMLIonButtonElement>(null)

  const onClick: () => void = () => {
    if (props.loading === undefined) {
      setLoading(true)
    }
    Promise.resolve(onSubmit())
      .catch(onError)
      .finally(() => {
        if (props.loading === undefined) {
          setLoading(false)
        }
      })
  }

  return (
    <IonButton
      disabled={!!disabled || !!loading}
      ref={ref}
      {...{...props, onClick: onClick}}
    >
      <div style={{
        position: "absolute",
        visibility: (!loading) ? "hidden" : "visible",
        width: "100%"
      }}>
        <IonSpinner name="dots"/>
      </div>
      <div
        style={{
          visibility: (!loading) ? "visible" : "hidden"
        }}
      >
        {element}
      </div>
    </IonButton>
  )
}


export { LoadingIonButton }